import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Row, Col, Button, Modal, Breadcrumb, Typography, Spin, Select } from 'antd';
import { fieldfilter } from '../../redux/actions/customFunction';
import {
  formItemLayout,
  tailFormItemLayout,
  backButton,
  handleBackendFormErrors,
  onlyNumbers,
  unexpectedError,
} from '../../common_functions';

const UpdateConfig = props => {
  const { section, id } = useParams();
  const [configData, setConfigData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [conditions, SetConditions] = useState([]);
  const [showSecondValue, setSecondValue] = useState(false);
  const [types, setTypes] = useState([]);
  const formRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let { data: { meta: { options: { choices: type = [] } = {} } = {} } = {} } = await props.fetchFieldValues('configuration', {
          fields: ['type'],
        });
        setTypes(type);

        let { data: { meta: { options: { choices: condition = [] } = {} } = {} } = {} } = await props.fetchFieldValues('configuration', {
          fields: ['condition'],
        });
        SetConditions(condition);

        let { data } = await props.getItem('configuration', id, { fields: ['id', 'name', 'value', 'value_2', 'type', 'condition'] });
        setSecondValue(!!condition && condition.length && fieldfilter(condition, data.condition).includes('Between') ? true : false);
        setConfigData(data);
        formRef.current.setFieldsValue(data);
      } catch (error) {
        console.error(error);
        unexpectedError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [section, id]);

  let onFinish = async values => {
    try {
      setLoading(true);
      let newState = { ...configData, ...values };
      values.value_2 === undefined && (newState = { ...newState, value_2: null });

      const response = await props.saveItem('configuration', newState);

      if (response) {
        setLoading(false);
        notification['success']({
          message: 'Configuration saved successfully!',
          duration: 2,
        });
        backButton(props, `/settings/configuration`);
      }
    } catch (errorResponse) {
      handleBackendFormErrors(formRef, errorResponse);
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = errorField => {
    formRef.current.setFieldsValue(errorField[0].name);
  };

  const showSecondField = e => {
    setSecondValue(!!conditions && conditions.length && fieldfilter(conditions, e).includes('Between') ? true : false);
  };

  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col className="app-breadcrumb-col">
          <Breadcrumb separator="/" items={[{ title: "Settings", href: "/settings/configuration" }, { title: "Configurations", href: "/settings/configuration" }, { title: "Edit Configuration" }]} />
        </Col>
        <Col className="white-paper">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                Edit Configuration
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end"></Col>
          </Row>
          <hr />
          <div className="artist">
            <Form
              ref={formRef}
              layout="vertical"
              {...formItemLayout}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{ layout: tailFormItemLayout }}
            >
              <Row gutter={24}>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <Form.Item
                    label="Field Name"
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: 'Field Name is required!',
                      },
                    ]}
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <Form.Item
                    label="Type"
                    name="type"
                    rules={[
                      {
                        required: true,
                        message: 'Type is required!',
                      },
                    ]}
                  >
                    <Select placeholder="Select type" optionFilterProp="children" disabled>
                      {types.map(col => {
                        return <Select.Option key={col.value} value={col.value}>{col.text}</Select.Option>;
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <Form.Item
                    label="Value"
                    name="value"
                    rules={[
                      {
                        validator: async (_, value) => {
                          let value_2 = formRef.current.getFieldValue('value_2');
                          if (eval(!!value_2 && Number(value) > Number(value_2))) {
                            return Promise.reject('Value should be less than or equal to second value.');
                          }
                          return Promise.resolve();
                        },
                      },
                      {
                        required: true,
                        message: 'Value is required!',
                      },
                    ]}
                  >
                    <Input
                      onKeyPress={e => {
                        onlyNumbers(e);
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              {!!showSecondValue && (
                <Row gutter={24}>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <Form.Item
                      label="Second Value"
                      name="value_2"
                      rules={[
                        {
                          validator: async (_, value_2) => {
                            let value = formRef.current.getFieldValue('value');
                            if (eval(!!value && Number(value_2) < Number(value))) {
                              return Promise.reject('Second value should be greater than or equal to value.');
                            }
                            return Promise.resolve();
                          },
                        },
                        {
                          required: true,
                          message: 'Second is required!',
                        },
                      ]}
                    >
                      <Input
                        onKeyPress={e => {
                          onlyNumbers(e);
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Row gutter={24}>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <Form.Item label="Condition" name="condition">
                    <Select placeholder="Select a condition" optionFilterProp="children" onChange={showSecondField}>
                      {conditions.map(col => {
                        return (
                          <Select.Option
                            key={col.value}
                            value={col.value}
                            disabled={configData.id === 11 && (col.text === 'Between' || col.text == 'Between or equal to')}
                          >
                            {col.text}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item {...tailFormItemLayout}>
                <Button
                  type="default"
                  htmlType="button"
                  onClick={() => backButton(props, '/settings/configuration')}
                  style={{
                    borderColor: '#d9d9d9',
                    background: '#f5f5f5',
                    color: 'rgba(0, 0, 0, 0.85)',
                  }}
                >
                  Back
                </Button>
                {props.showButton(props.roleType, props.tabs_permissions.settings_configuration, !!conditions ? conditions.id : '')}
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

export default UpdateConfig;
